import { Pipe, PipeTransform } from '@angular/core';
import { Workarea } from '../workarea.class';

@Pipe({
    name: 'workareasBoundsCount',
    standalone: false,
})
export class WorkareasBoundsCountPipe implements PipeTransform {
    transform(workareas: Workarea[] | null | undefined, bounds: google.maps.LatLngBounds | null | undefined): number {
        if (!workareas?.length) return 0;
        if (!bounds) return workareas.length;

        return workareas.filter(w => {
            const lat = typeof (w as any).lat === 'string' ? parseFloat((w as any).lat) : (w as any).lat;
            const lng = typeof (w as any).lng === 'string' ? parseFloat((w as any).lng) : (w as any).lng;
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
            return bounds.contains(new google.maps.LatLng(lat, lng));
        }).length;
    }
}
